import head from 'lodash/head';
import last from 'lodash/last';

export default {
   props: {
      period: {
         type: Array,
         default: []
      }
   },
   computed: {
      minExtent() {
         return head(this.period);
      },
      maxExtent() {
         return last(this.period);
      }
   }
};
